import React from 'react';
import Button from 'olive-react-myoneui/lib/Button';
import { checkCircleFill, checkCircleComplete, clockIcon } from "../../../constants/icons";
import Accordion from 'olive-react-myoneui/lib/Accordion';

const ArchiveProgressAccordion = ({
  className,
  lectures,
  maxAttempts,
  enableSequentialProgress = false,
  onRetryClick,
  onStartClick,
  onContinueClick,
  onViewCertificateClick,
  certificateUrl,
  isCertificateOnlyArchived,
  resetResult,
}) => {
  const updateLectureStatuses = (lectures) => {
    if (isCertificateOnlyArchived == 1) return [];
    return lectures.map((lecture) => {
      if (lecture.subTopics?.length) {
        const allSubTopicsCompleted = lecture.subTopics.every(
          (subTopic) => subTopic.status === "completed"
        );
        lecture.status = allSubTopicsCompleted ? "completed" : lecture.status;
      }
      return lecture;
    });
  };

  const renderActionButton = (item, isDisabled) => {
    if (item.attempts >= maxAttempts) {
      return (
        <Button variant="outline" className="btn-round btn-sm border-0 py-2" disabled>
          Max attempts reached
        </Button>
      );
    }
    
    if (item.status === "notStarted") {
      return (
        <Button
          variant="primary"
          className="btn-round btn-sm py-2"
          disabled={isDisabled}
          onClick={() => onStartClick(item)}
        >
          Start
        </Button>
      );
    }
    return (
      <Button
        variant="primary"
        className="btn-round btn-sm py-2"
        disabled={isDisabled}
        onClick={() => onContinueClick(item)}
      >
        Continue
      </Button>
    );
  };

  const updatedLectures = updateLectureStatuses(lectures);
  const isCourseCompleted = certificateUrl && resetResult == 0 ? 1 : 0;

  return (
    <div className={`${className || ""} myk__stu-courses-progress-wrapper`}>
      <Accordion alwaysOpen>
        {updatedLectures.map((lecture, index) => {
          const isLectureDisabled =
            enableSequentialProgress &&
            (index > 0 && updatedLectures[index - 1].status !== "completed");

          return (
            <Accordion.Item
              key={index}
              eventKey={`lecture-${index}`}
              className={isLectureDisabled ? "disabled" : lecture.status}
            >
              <Accordion.Header as="div" className="flex-wrap">
                {lecture.status === "completed" ? checkCircleFill : checkCircleComplete}
                <h3>{index + 1}. {lecture.title}</h3>
              </Accordion.Header>
              <Accordion.Body className="pt-1">
                {lecture.subTopics?.length > 0 && (
                  <Accordion alwaysOpen className="myk__stu-lecture-subtopics">
                    {lecture.subTopics.map((subTopic, subIndex) => (
                      <Accordion.Item
                        key={subIndex}
                        eventKey={`lecture-${index}-subTopic-${subIndex}`}
                        className={isLectureDisabled ? "disabled" : subTopic.status}
                      >
                        <Accordion.Header as="div" className="flex-wrap">
                          {subTopic.status === "completed" ? checkCircleFill : checkCircleComplete}
                          <h4>{subIndex + 1}. {subTopic.title}</h4>
                        </Accordion.Header>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                )}
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
        <Accordion.Item
          eventKey="certificate"
          className={isCourseCompleted ? "completed accordion-item-certificate" : "in-progress accordion-item-certificate"}
        >
          <Accordion.Header as="div" className="flex-wrap">
            {isCourseCompleted ? checkCircleFill : checkCircleComplete}
            <h3>
              {updatedLectures.length + 1}. Certificate{" "}
              {certificateUrl && resetResult === 0 && (
                <span className="badge badge-completed">Completed</span>
              )}            
            </h3>
          </Accordion.Header>
          <Accordion.Body className="pt-0">
            {certificateUrl && resetResult == 0 ? (
              <>
                <p>Congratulations on completing the course successfully. Click on the "View Certificate" button to download your certificate.</p>
                <Button variant="primary" className="btn-round btn-sm py-2" onClick={onViewCertificateClick}>
                  View Certificate
                </Button>
              </>
            ) : (
              <p>Certificate not available.</p>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default ArchiveProgressAccordion;

